const STORAGE_KEY = "jfy_recent_categories";
const MAX_CATEGORIES = 3;
export const PERSONALIZATION_UPDATED_EVENT = "personalizationUpdated";

/**
 * Returns stored recently viewed listings, oldest first, most recent last.
 * Each entry: { title, handle, type, ts }
 * type is the product_list param prefix: category | collection | brand | vendor.
 * Entries saved before type existed are treated as category.
 */
export function getRecentCategories() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    const parsed = stored ? JSON.parse(stored) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.map((entry) => ({
      ...entry,
      type: entry?.type || "category",
    }));
  } catch {
    return [];
  }
}

/**
 * Records a listing visit, moving it to the most-recent slot.
 * Deduplicates by type + handle and caps the list at MAX_CATEGORIES (FIFO eviction).
 * @param {{ title?: string, handle: string, type?: string }} category
 */
export function saveCategoryClick({ title, handle, type = "category" } = {}) {
  if (!handle) return;
  const listingType = type || "category";
  try {
    const categories = getRecentCategories().filter(
      (c) => !(c.handle === handle && c.type === listingType)
    );
    categories.push({ title, handle, type: listingType, ts: Date.now() });
    if (categories.length > MAX_CATEGORIES) categories.shift();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(categories));
    // Notify listeners (e.g. PersonalizedBestSellersCarousel) in the same tab
    window.dispatchEvent(
      new CustomEvent(PERSONALIZATION_UPDATED_EVENT, { detail: categories })
    );
  } catch {}
}
